import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import InputDropdown from "@/Components/Form/InputDropdown";
import { LuChevronDown } from "@/Components/Icons/Icons";
import { useInvoice } from "@/Context/InvoiceContext";
import { useUser } from "@/Context/UserContext";
import { hookMap } from "@/redux/hookMap";
import { useParams } from "react-router";
import { importHookMap } from "@/redux/importHookMap";

export default function ProductTabBox({ handleRowSelect }) {
  const { invoiceId, setInvoiceId } = useInvoice();
  const { formData, setFormData } = useUser();
  const invoice = formData["invoiceMain"] || [];

  const options = invoice.map((inv) => ({
    value: inv.importInvoiceId,
    label: inv.importInvoiceNumber,
  }));

  // ✅ Find the selected invoice from the array using the current invoiceId
  const selectedInvoice = invoice.find(
    (inv) => inv.importInvoiceId === invoiceId
  );
// ✅ Get values safely
const productValue = selectedInvoice?.importProductValue ?? "0";
const termsOfInvoice = selectedInvoice?.importInvoiceTOI ?? "0";
const InvoiceUpdateDate = selectedInvoice?.importInvoiceDate?.split(" ")[0]  ?? "N/A";

  const { fetch: fetchInvoice, data, isLoading } = importHookMap.invoiceMain();
  const { importerId } = useParams();

  // 🔹 Fetch invoice list when importerId changes
  useEffect(() => {

    if (importerId && !formData.invoiceMain?.length) {
      console.log("➡️ Fetching invoiceMain for importerId:", importerId);
      fetchInvoice({ id: importerId })
        .then((res) => {
          console.log(res,"res check for invoice")
          setFormData((prev) => ({ ...prev, invoiceMain: res || [] }));
        })
        .catch((err) => console.error("❌ Failed to fetch invoiceMain:", err));
    }
  }, [importerId]);

  // 🔹 Handle auto-selection logic
  useEffect(() => {

    if (invoice.length === 0) {
      return;
    }

    const selectedInvoice = invoice.find((inv) => inv.selected);

    if (selectedInvoice) {
      setInvoiceId(selectedInvoice.importInvoiceId);
    } else {
       const updatedInvoices = invoice.map((inv, index) => ({
        ...inv,
        selected: index === 0 ? true : false, // ← select 1st only
      }));

      setFormData((prev) => ({
        ...prev,
        invoiceMain: updatedInvoices,
      }));
      setInvoiceId(updatedInvoices[0].importInvoiceId);
    }
  }, [invoice]);

  // 🔹 Handle dropdown change
  const handleChange = (e) => {
    console.log("🔄 Invoice dropdown changed:", e);
    setInvoiceId(e);
    handleRowSelect(e, "invoiceMain");
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ px: 2, paddingTop: 2, paddingBottom: 0.5, gap: 10 }}
    >
      {/* Invoice Number */}
      <Box display="flex" alignItems="center" gap={1.5}>
        <Typography variant="bodyMedium" sx={{ minWidth: "100px" }}>
          Invoice Number:
        </Typography>
        <InputDropdown
          gap={false}
          value={invoiceId}
          onChange={handleChange}
          options={options}
          placeholder="Select Invoice"
          width="200px"
          sx={{ mt: 0.5 }}
          endIconName={LuChevronDown}
        />
        <Typography variant="bodyMedium">{InvoiceUpdateDate}</Typography>
      </Box>

      {/* Product Value + Terms Of Invoice */}
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="center"
        gap={2}
        flexWrap="wrap"
      >
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography variant="bodySmall" color="text.secondary">
            Product Value:
          </Typography>
          <Typography variant="bodySmall" fontWeight={600}>
            {productValue}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography fontSize="14px" color="text.secondary">
            Terms Of Invoice:
          </Typography>
          <Typography fontSize="14px" fontWeight={600}>
            {termsOfInvoice}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
